// extracted by mini-css-extract-plugin
export default {"screenHeading":"screenheading_screenHeading__ogKd6","title":"screenheading_title__l0n4U","image":"screenheading_image__Z9qhk","subtitle":"screenheading_subtitle__j2ctq"};